import type { ThemeOptions } from '@mui/material';

import type { Theme } from '../themes';
import { createTheme as createBaseTheme } from './main';
import { tokenPaletteLight, tokenPaletteMain } from './primitives/tokenPalette';

// Theme used by flex-footer and advice box green/blue

const options = {
  palette: {
    background: {
      default: '#FAFAFA',
      paper: '#FFFFFF',
    },
    text: {
      overline: '#D10000',
      link: '#D10000',
    },
    button: {
      secondary: {
        backgroundActive: 'rgba(0,0,0,0.06)',
        backgroundHover: 'rgba(0,0,0,0.03)',
        color: '#000000',
        colorActive: '#000000',
        colorHover: '#000000',
        colorFocus: '#000000',
        shadowHover: '#949494',
        shadowFocus: '#0047FF',
        shadowDisabled: '#E3E3E3',
      },
    },
    ...tokenPaletteMain,
    ...tokenPaletteLight,
  },
};

export function createTheme(...overrideTheme: ThemeOptions[]): Theme {
  return createBaseTheme(options, ...overrideTheme);
}

export const theme: Theme = createTheme();
